/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createReviver } from '../../factoriesAny.js';
export var reviverDependencies = {
  createReviver
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesReviver.generated.js
// module id = 1455
// module chunks = 2